<template>
  <div class="Aventure Page__container">
    <div v-html="text" />
  </div>
</template>

<script>
export default {
  name: 'Aventure',
  computed: {
    text() {
      return this.$store.getters['app/pages']['options/aventure'][this.lang].text
    }
  }
}
</script>

<style lang="stylus">
@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Aventure
  position relative
</style>



// WEBPACK FOOTER //
// src/components/navigation/pages/Aventure.vue